export default function LoadingOverlay ({ message = null }) {
    return (
      <>
        {/* Blurred background overlay */}
        <div className="absolute inset-0 bg-white/15 backdrop-blur-[3px] [-webkit-backdrop-filter:blur(3px)] z-[1000] transition-[backdrop-filter] duration-300"></div>

        {/* Content on top (no blur) */}
        <div className="absolute inset-0 flex items-center justify-center z-[1001] pointer-events-none">
          <div className="flex flex-col items-center gap-4">
            <div className="w-12 h-12 border-5 border-t-[var(--odp-purple-light)] border-gray-300 rounded-full animate-spin"></div>
            {message && (
              <p className="text-gray-700 text-sm font-medium text-center max-w-xs">
                {message}
              </p>
            )}
          </div>
        </div>
      </>
    );
  };
  